import { INVENTORY_TYPE } from 'constants/inventory';

export const INVENTORY_LIST_TAB = {
  field: 'inventory_type',
  multiSelect: false,
  tabs: INVENTORY_TYPE,
};
